/*
 * @Author: 党方超
 * @Date: 2020-08-18 09:33:37
 * @LastEditTime: 2021-02-23 08:58:21
 * @LastEditors: Please set LastEditors
 * @Description: 总路由页面
 * @FilePath: /dmps-console-web/src/router/route.js
 */
const main = () => import('../views/main')
const mainOpen = () => import('../views/main-open')
const access = () => import('../views/access')
const login = () => import('../views/access/login')
const register = () => import('../views/access/register')
const forget = () => import('../views/access/forget')
const reset = () => import('../views/access/reset')
const result = () => import('../views/access/result')
const home = () => import('../views/home')
const page404 = () => import('../views/404')
const unsubscribe = () => import('../views/unsubscribe')

import userManage from './user-manage'
import system from './system'
import publishing from './publishing'
import submissonsMenu from './author'
import reviewersMenu from './reviewers-menu'
import editorialOffice from './editorial-office'
import academicMenu from './academic-menu'
import statistic from './statistic'

import open from './open'

//按模块拆分路由

const Routers = [
  userManage,
  system,
  publishing,
  submissonsMenu,
  reviewersMenu,
  editorialOffice,
  academicMenu,
  statistic
]

const MainRouter = {
  path: '/main',
  component: main,
  redirect: '/home',
  name: '主页',
  children: [
    {
      // 首页
      path: '/home',
      component: home,
      name: '/home'
    },
    {
      // 404
      path: '/404',
      component: page404,
      name: '/404'
    }
  ]
}

//拼接路由
Routers.map(route => {
  route.map(item => {
    MainRouter.children.push(item)
  })
})

//渲染路由
export const routers = [
  {
    path: '',
    redirect: '/access/login'
  },
  MainRouter,
  {
    path: '/access/result',
    component: result,
    meta: { noCheckSession: true }
  },
  //用户登录路由
  {
    path: '/access',
    component: access,
    meta: { noCheckSession: true },
    children: [
      {
        path: '/access/login',
        component: login,
        meta: { noCheckSession: true }
      },
      {
        path: '/access/register',
        component: register,
        meta: { noCheckSession: true }
      },
      {
        path: '/access/forget',
        component: forget,
        meta: { noCheckSession: true }
      },
      {
        path: '/access/reset',
        component: reset,
        meta: { noCheckSession: true }
      }
    ]
  },
  {
    // 退订
    path: '/unsubscribe',
    component: unsubscribe,
    name: '/unsubscribe'
  },
  {
    path: '/main-open',
    component: mainOpen,
    redirect: '/access/login',
    name: '主页',
    children: open
  },
  {
    path: '*',
    redirect: '/404'
  }
]
